// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { HostService } from '../_generated/host.service';
import {
  CreateTicketRequestInterface,
  CreateTicketResponseInterface,
  GetUserByPhoneRequestInterface,
  GetUserByPhoneResponseInterface,
  ListCommentsRequestInterface,
  ListCommentsResponseInterface,
  ListTicketsRequestInterface,
  ListTicketsResponseInterface,
  SearchTicketsRequestInterface,
  SearchTicketsResponseInterface,
} from './interfaces/index';
import {
  CreateTicketRequest,
  CreateTicketResponse,
  GetUserByPhoneRequest,
  GetUserByPhoneResponse,
  ListCommentsRequest,
  ListCommentsResponse,
  ListTicketsRequest,
  ListTicketsResponse,
  SearchTicketsRequest,
  SearchTicketsResponse,
} from './objects/index';

@Injectable()
export class SupportApiService {
  constructor(
    private http: HttpClient,
    private hostService: HostService,
  ) {}

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }

  createTicket(r: CreateTicketRequest | CreateTicketRequestInterface): Observable<CreateTicketResponse> {
    const request = (<CreateTicketRequest>r).toApiJson ? <CreateTicketRequest>r : new CreateTicketRequest(r);
    return this.http
      .post<CreateTicketResponseInterface>(
        this.hostService.hostWithScheme() + '/support.v1.Support/CreateTicket',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => CreateTicketResponse.fromProto(resp)),
        share(),
      );
  }
  getUserByPhone(r: GetUserByPhoneRequest | GetUserByPhoneRequestInterface): Observable<GetUserByPhoneResponse> {
    const request = (<GetUserByPhoneRequest>r).toApiJson ? <GetUserByPhoneRequest>r : new GetUserByPhoneRequest(r);
    return this.http
      .post<GetUserByPhoneResponseInterface>(
        this.hostService.hostWithScheme() + '/support.v1.Support/GetUserByPhone',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => GetUserByPhoneResponse.fromProto(resp)),
        share(),
      );
  }
  listTickets(r: ListTicketsRequest | ListTicketsRequestInterface): Observable<ListTicketsResponse> {
    const request = (<ListTicketsRequest>r).toApiJson ? <ListTicketsRequest>r : new ListTicketsRequest(r);
    return this.http
      .post<ListTicketsResponseInterface>(
        this.hostService.hostWithScheme() + '/support.v1.Support/ListTickets',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => ListTicketsResponse.fromProto(resp)),
        share(),
      );
  }
  listComments(r: ListCommentsRequest | ListCommentsRequestInterface): Observable<ListCommentsResponse> {
    const request = (<ListCommentsRequest>r).toApiJson ? <ListCommentsRequest>r : new ListCommentsRequest(r);
    return this.http
      .post<ListCommentsResponseInterface>(
        this.hostService.hostWithScheme() + '/support.v1.Support/ListComments',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => ListCommentsResponse.fromProto(resp)),
        share(),
      );
  }
  searchTickets(r: SearchTicketsRequest | SearchTicketsRequestInterface): Observable<SearchTicketsResponse> {
    const request = (<SearchTicketsRequest>r).toApiJson ? <SearchTicketsRequest>r : new SearchTicketsRequest(r);
    return this.http
      .post<SearchTicketsResponseInterface>(
        this.hostService.hostWithScheme() + '/support.v1.Support/SearchTickets',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => SearchTicketsResponse.fromProto(resp)),
        share(),
      );
  }
}
